import { useEffect, useState } from 'react';
import { Field } from "formik";
import ServiceAgreementHtml from "../service-agreement";
import { Modal } from "react-bootstrap";

const IntakeTermsAndConditionsFields = ({ errors, touched, values, nested, showModal, toggleModal, generalInformation, orderNumber  }) => {
    return (
        <div className="form-wrapper">
                <div className="form-check form-footer-check">
                    <Field type="checkbox" name={nested ? 'acceptTerms.acceptTerms' : 'acceptTerms'} id="acceptTerms"/>
                    <label className="form-check-label" id="terms-conditions-label">
                        By checking this box, you are hereby acknowledging and agreeing that you have read, understood and agree to the terms of this <a onClick={toggleModal}>Service Agreement</a> dated 10/26/2026.
                    </label>

                    {errors && touched ? (
                        <div className="form-error">{errors}</div>
                    ) : null}
                </div>

                <Modal backdrop="static" show={showModal} onHide={toggleModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Service Agreement</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="no-padding">
                        <ServiceAgreementHtml client={`${generalInformation.firstNameClient} ${generalInformation.lastNameClient}`} orderNumber={orderNumber} />
                    </Modal.Body>
                </Modal>
        </div>
    );
};

export default IntakeTermsAndConditionsFields;